<template>
  <v-container fluid class="exams">
    <v-card flat>
      <v-card-title>
        <p>My Withdrawals</p>
        <v-spacer />
        <v-btn color="primary" :to="{ name: 'ExamWithdrawalCard' }">
          Apply For Withdrawal
        </v-btn>
      </v-card-title>
      <v-divider />
      <v-card-text>
        <v-data-table
          :items="withdrawals"
          :sort-by="['documentDate']"
          :sort-desc="[true]"
          hide-default-footer
          :headers="headers"
        >
          <template v-slot:[`item.ID`]="{ index }">
            <span>{{ index + 1 }}</span>
          </template>
          <template v-slot:[`item.programme`]="{ item }">
            <span>{{ item["programme"] }}</span>
          </template>
          <template v-slot:[`item.session`]="{ item }">
            <span>{{ item["intakeYear"] }}, {{ item["intakeSemester"] }}</span>
          </template>
          <template v-slot:[`item.status`]="{ item }">
            <span
              ><v-icon size="12" :color="statusColor[item.status.toLowerCase()]"
                >mdi-radiobox-marked</v-icon
              >
              {{ item["status"] }}</span
            >
          </template>
          <template v-slot:[`item.totalAmount`]="{ item }">
            <span>{{ item["totalAmount"] | currencyFormat }}</span>
          </template>
          <!--BEGIN board actions-->
          <template v-slot:[`item.action`]="{ item }">
            <v-menu open-on-hover>
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  class="text-capitalize links"
                  text
                  v-bind="attrs"
                  v-on="on"
                  small
                  ><v-icon>mdi-dots-vertical</v-icon>
                </v-btn>
              </template>
              <v-list>
                <v-list-item
                  :to="{
                    name: 'ExamWithdrawalCard',
                    params: { code: encryptedParam(item.no) },
                  }"
                >
                  <span class="table-exam">
                    <v-icon color="primary">mdi-eye</v-icon>
                    View
                  </span>
                </v-list-item>
                <v-divider />
                <v-list-item
                  @click="deleteWithdrawal(item)"
                  v-if="item.status === 'Open'"
                >
                  <span class="table-exam">
                    <v-icon color="error"> delete </v-icon>
                    Delete
                  </span>
                </v-list-item>
              </v-list>
            </v-menu>
          </template>
          <!--END board actions-->
        </v-data-table>
      </v-card-text>
    </v-card>
  </v-container>
</template>

<script>
import status from "@/packages/applications/status";
import { helper } from "../../../../dashboard/utils";

export default {
  name: "ExamWithdrawalComponent",
  data: () => ({
    headers: [
      { text: "#S/N", value: "ID", sortable: false },
      { text: "Reference No.", value: "no", sortable: false },
      { text: "Applied On", value: "documentDate", sortable: false },
      { text: "Programme", value: "programme", sortable: false },
      { text: "Stage", value: "stage", sortable: false },
      { text: "Amount", value: "amount", sortable: false },
      { text: "Status", value: "status", sortable: false },
      { text: "Actions", value: "action", sortable: false },
    ],
  }),
  computed: {
    withdrawals() {
      return this.$store.getters["Withdrawal/withdrawalGetters"]("withdrawals");
    },
    statusColor() {
      return status;
    },
  },
  methods: {
    deleteWithdrawal(item) {
      this.$confirm.show({
        title: "Delete Withdrawal Entry",
        text: "Are you sure you want to delete this withdrawal entry, this action is irreversible",
        onConfirm: () => {
          this.$store.dispatch("Withdrawal/deleteWithdrawal", { ...item });
        },
      });
    },
    encryptedParam(item) {
      return helper.encrypt(item);
    },
  },
};
</script>

<style scoped></style>
